import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type {
  ClientAppCertificateShowResponseData,
  ClientAppCertificatesResponseData,
} from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const clientAppCertificateKeys = {
  all: () => ['clientAppCertificates'] as const,
  list: (props: { url: string }) =>
    [...clientAppCertificateKeys.all(), 'list', props.url] as const,
  detail: (props: { url: string }) =>
    [...clientAppCertificateKeys.all(), 'detail', props.url] as const,
};

export const clientAppCertificateQueries = {
  list: (props: { url: string }) =>
    queryOptions({
      queryKey: clientAppCertificateKeys.list(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<ClientAppCertificatesResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),

  detail: (props: { url: string }) =>
    queryOptions({
      queryKey: clientAppCertificateKeys.detail(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<ClientAppCertificateShowResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: true,
      placeholderData: keepPreviousData,
    }),
};
